module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("For my mam and dad. For bringing me up fed well, safe, and warm, and raising me with love and care. I never fully appreciated how much you did until I became a parent myself.")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_vm._v("Thank you xxx")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0